import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { ExternalLink, NamedLink, ResponsiveImage } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './CatalogItem.css';

const CatalogItem = ({
  catalogItem = null,
  intl,
  isHighlighted = false
}) => {
  const itemRef = useRef(null);
  const location = useLocation();

  const {
    articleCode,
    description,
    externalLink,
    title,
    shortTitle,
    index
  } = catalogItem.attributes;
  const catalogItemId = catalogItem.id.uuid;

  const image =
    catalogItem.images && catalogItem.images.length > 0 ? catalogItem.images[0] : null;

  useEffect(() => {
    if (isHighlighted && itemRef.current) {
      const timer = setTimeout(() => {
        itemRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 150);

      return () => clearTimeout(timer);
    }
  }, [isHighlighted]);

  return (
    <div 
      ref={itemRef} 
      className={classNames(css.itemContainer, { [css.highlightedItem]: isHighlighted })} 
      key={catalogItemId}
    >
      <div className={css.imgContainer}>
        <div className={css.aspectWrapper}>
          <ResponsiveImage
            rootClassName={css.rootForImage}
            alt={title}
            image={image}
            variants={['scaled-medium']}
          />
        </div>
      </div>
      <div className={css.detailsContainer}>
        <div className={css.details}>
          <p className={css.title}>{title}</p>
          <p className={css.text}>
            {intl.formatMessage({ id: 'Console.catalogItemCode' })}: {articleCode}
          </p>
          <p className={css.text}>{description}</p>
          <p className={css.text}>{intl.formatMessage({ id: 'Console.shortTitleCode' })}: {shortTitle}</p>
          <p className={css.text}>Index: {index}</p>
        </div>
        <div className={css.linkContainer}>
          <NamedLink 
            className={css.link} 
            name="EditItemPage" 
            params={{ id: catalogItemId, type: 'edit' }}
            to={{ search: location.search }}
          >
            <FormattedMessage id="Console.editCatalogItem" />
          </NamedLink>
          {externalLink &&
            <>
              <span> • </span>
              <ExternalLink href={externalLink} className={css.link}>
                {intl.formatMessage({ id: "Console.externalLink" })}
              </ExternalLink>
            </>
          }
        </div>
      </div>
    </div>
  );
};

export default CatalogItem;
